module.exports = __webpack_public_path__ + "img/RB_Falchion.3d31286b.png";